<template>
  <ion-page class="five-page flex-column justify-between align-center">
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div class="nav-icon"></div>
        <span>资料选择</span>
        <img
          class="nav-icon cursor-pointer"
          :src="getBrandImageUrl('close_icon.png')"
          alt=""
          @click="onClose"
        />
      </div>
    </ion-header>
    <div class="five-page_center flex-column align-center">
      <div class="label">为你设计有针对性的资<br />料，迅速提高水平</div>
      <div class="six">
        <img class="outside-line" src="@/assets/student/version5/outside_line.svg" alt="" />
        <img class="six-center" src="@/assets/student/version5/six_center.svg" alt="" />
        <!--单词识记-->
        <img
          v-if="getCourseTypeId() !== 1"
          class="six-1"
          src="@/assets/student/version5/word_recognition.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 1"
          class="six-1"
          src="@/assets/student/version5/true_word_recognition.svg"
          alt=""
          @click="openNine"
        />
        <!--语法训练-->
        <img
          v-if="getCourseTypeId() !== 2"
          class="six-2"
          src="@/assets/student/version5/grammar_test.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 2"
          class="six-2"
          src="@/assets/student/version5/true_grammar_test.svg"
          alt=""
          @click="openNewGrammar"
        />
        <!--阅读理解-->
        <img
          v-if="getCourseTypeId() !== 3 && getCourseTypeId() !== 4"
          class="six-3"
          src="@/assets/student/version5/reading_comprehension.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 3 || getCourseTypeId() === 4"
          class="six-3"
          src="@/assets/student/version5/true_reading_comprehension.svg"
          alt=""
          @click="openReading"
        />
        <!--听口训练-->
        <img
          v-if="getCourseTypeId() !== 46"
          class="six-4"
          src="@/assets/student/version5/hearing_test.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 46"
          class="six-4"
          src="@/assets/student/version5/true_hearing_test.svg"
          alt=""
          @click="openListening"
        />
        <!--无忧写作-->
        <img
          v-if="getCourseTypeId() !== 13"
          class="six-5"
          src="@/assets/student/version5/writing_test.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 13"
          class="six-5"
          src="@/assets/student/version5/true_writing_test.svg"
          alt=""
          @click="openGrammar"
        />
        <!--词汇测试-->
        <img
          class="six-6"
          src="@/assets/student/version5/true_vocabulary_test.svg"
          alt=""
          @click="openVocabularyTest"
        />
      </div>
    </div>
    <div class="bottom-logo">
      <!--      <img src="@/assets/student/version5/bottom_logo.svg" alt="" />-->
    </div>
  </ion-page>
</template>

<script>
import { IonHeader, IonPage, modalController } from "@ionic/vue"

import { closeOutline } from "ionicons/icons"

import Card from "@/components/CardCom.vue";
import DisabledCard from "@/components/DisabledCard.vue";
import PageWhiteBackground from "@/components/PageWhiteBackground.vue";
import VocabularyTest from "@/views/personal/VocabularyTest";
import Nine from "@/views/speed/Nine";
import NewGrammarDirectory from "@/views/grammar/newGrammar/Directory";
import ListeningDirectory from "@/views/listening/Directory";
import OldGrammarIndex from '@/views/grammar/Index.vue'
import ReadingIndex from "@/views/reading/Index";
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";

export default {
  name: "SpeedIndex",
  components: {
    IonHeader,
    DisabledCard,
    Card,
    PageWhiteBackground,
    IonPage,
  },
  props: ["studentId", "courseId"],

  setup() {
    return {
      closeOutline,
    }
  },

  data() {
    return {
      clockTimer1: undefined,
      clockTimer2: undefined,
      remainingTime: undefined, //剩余时间
      isReminded: false, //是否提醒过
      isFinished: false, //是否结束
      appointment: {},
      brandImages: BRAND_IMAGES,
      listenStore:useListenConfigStore()
    };
  },

  mounted() {
    this.userinfo = this.store.getUser()
    this.appointment = this.store.getAppointment()
    /*    this.readRemainingTime();
    this.startTimer();*/
  },

  methods: {
    getBrandImageUrl,
    /**
     * @param this.getCourseTypeId - 练习课练习类型 1 单词速记 2 语法 3 阅读理解和完型
     * @param this.appointment.classification - 资料类型 3 体验课 2 60分钟 1 30分钟
     * */
    async openNine() {
      if (this.getCourseTypeId() != 1 && this.appointment.classification != 3) {
        return
      }
      const modal = await modalController.create({
        component: Nine,
        componentProps: { studentId: this.studentId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    async openVocabularyTest() {
      this.ajax
        .get("/vocabulary/createVocabularyTest?userId=" + this.studentId)
        .then(async (res) => {
          if (res.data.success) {
            const modal = await modalController.create({
              component: VocabularyTest,
              componentProps: {
                testId: res.data.data.testId,
                testUserId: this.studentId,
              },
              cssClass: "modal_controller_class",
            })
            return modal.present()
          }
        })
    },

    //打开旧版语法练习页面
    async openGrammar() {
      const modal = await modalController.create({
        component: OldGrammarIndex,
        componentProps: { courseId: this.courseId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    //打开语法练习页面
    async openNewGrammar() {
      sessionStorage.removeItem("isPrepare") //移除备课状态
      if (this.courseId === 2054 || this.courseId === 629 || this.courseId === 394) {
        //兼容最初版语法
        this.openGrammar()
      } else {
        const modal = await modalController.create({
          component: NewGrammarDirectory,
          componentProps: { courseId: this.courseId },
          cssClass: "modal_controller_class",
        })
        return modal.present()
      }
    },

    //打开听口训练页面
    async openListening() {
      const modal = await modalController.create({
        component: ListeningDirectory,
        componentProps: { courseId: this.courseId,studentId: this.studentId, },
        cssClass: "modal_controller_class",
      });
      return modal.present().then(_=>{
        this.listenStore.setListenPrepare(false)
      });
    },

    //打开阅读理解页面
    async openReading() {
      const modal = await modalController.create({
        component: ReadingIndex,
        componentProps: { studentId: this.studentId, courseId: this.courseId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    routerBack() {
      modalController.dismiss()
    },
    getCourseTypeId() {
      let courseTypeId = 1
      const appointment = this.store.getAppointment()
      if (appointment && appointment.courseTypeId) {
        //课程类型没获取到
        courseTypeId = appointment.courseTypeId
      }
      return courseTypeId
    },

    //同步剩余时间
    readRemainingTime() {
      const appointment = this.store.getAppointment()
      if (!appointment.aptmId) {
        return
      }
      if (appointment != null) {
        this.ajax.get("/record/readRemainingTime?aptmId=" + appointment.aptmId).then((res) => {
          if (res.data.success) {
            console.log("同步了剩余时间：" + res.data.time)
            this.remainingTime = res.data.time
          }
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.five-page {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: linear-gradient(180deg, #dcf8ef 0%, #f2f3f7 30%);

  .navbar {
    width: 100%;
    height: 5rem;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: 600;
    padding: 0 1rem;

    .nav-icon {
      width: 1.2rem;
    }
  }

  .bottom-logo {
    width: 70%;
    height: 3rem;

    img {
      width: 100%;
    }
  }

  &_center {
    padding-bottom: 8rem;

    .label {
      font-size: 1.1rem;
      color: #606266;
      line-height: 1.5rem;
      text-align: center;
    }

    .six {
      margin-top: 5rem;
      width: 22rem;
      height: 22rem;
      position: relative;

      .outside-line {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
      }

      .six-center {
        position: absolute;
        top: 49%;
        left: 51%;
        transform: translate(-50%, -50%);
        width: 40%;
        z-index: 2;
      }

      &-1 {
        position: absolute;
        left: 52%;
        top: 4%;
        width: 7.6rem;
        z-index: 3;
      }

      &-2 {
        position: absolute;
        left: 72%;
        top: 28%;
        width: 5.3rem;
        z-index: 3;
      }

      &-3 {
        position: absolute;
        left: 54%;
        top: 63%;
        width: 7.6rem;
        z-index: 3;
      }

      &-4 {
        position: absolute;
        left: 16%;
        top: 66%;
        width: 7.6rem;
        z-index: 3;
      }

      &-5 {
        position: absolute;
        left: 5%;
        top: 34%;
        width: 5.3rem;
        z-index: 3;
      }

      &-6 {
        position: absolute;
        left: 12%;
        top: 5%;
        width: 7.6rem;
        z-index: 3;
      }
    }
  }
}
</style>
